import NoImg from './Assets/Summary-Img/default-png-9.png'

export const BASEURL = `https://master.sevenrocks.in/survey-api`

export const DEFAULT_IMG  = NoImg